// Assets de marca de LucyCare (locales, sin dependencia de hosts externos).
// El logo vive en public/lucycare-logo.png — referenciarlo siempre por esta
// constante para que migrar a un SVG/alta-res en el futuro sea un solo cambio.
export const LUCYCARE_LOGO_SRC = '/lucycare-logo.png';
